<template>
    <div class="overlay">
      <div class="modal-wrapper p-4 bg-white rounded shadow">
        <portlet :actionsBlock="true">
          <template #portletBody>
            <div class="container">
              <div class="row">
                <div class="col-md-4">
                  <div
                    class="d-flex justify-content-between align-items-center mb-2 p-3 bg-light"
                  >
                    <span class="font-weight-bold">Select all team</span>
                    <input
                      type="checkbox"
                      v-model="selectAll"
                      @change="toggleSelectAll"
                    />
                  </div>
                  <div class="user-list rounded p-2">
                    <div
                      v-for="user in users"
                      :key="user.id"
                      class="d-flex justify-content-between align-items-center mb-2 p-2"
                    >
                      <span>{{ user.name }}</span>
                      <input
                        type="checkbox"
                        v-model="selectedUsers"
                        :value="user.id"
                      />
                    </div>
                    <p v-if="users.length === 0" class="text-muted text-center">users
                      No users available
                    </p>
                  </div>
                </div>
  
                <div class="col-md-8">
                    <h4 class="mb-5">Create Notification</h4>
                    <div class="form-group mb-4">
                        <input type="text"
                            class="form-control"
                            v-model="subject"
                            placeholder="Reminder subject…" 
                        />
                    </div>
                    <div class="form-group d-flex flex-wrap mb-4">
                        <div v-for="opt in recurrenceOptions"
                            :key="opt.value"
                            class="custom-control custom-radio mr-4 mb-2">
                            <input  type="radio"
                                    class="custom-control-input"
                                    name="recurrence"
                                    :id="opt.value"
                                    :value="opt.value"
                                    v-model="recurrence">
                            <label class="custom-control-label" :for="opt.value">
                            {{ opt.label }}
                            </label>
                        </div>
                    </div>
                    <div class="form-row align-items-center mb-4">
                        <template v-if="recurrence==='one-off' || recurrence==='daily'">
                        <input type="time"
                                class="form-control col-auto"
                                v-model="timeOfDay">
                        </template>

                        <template v-else-if="recurrence==='weekly'">
                            <select class="form-control col-auto mr-2 mb-3" v-model="weekday">
                                <option v-for="(d,i) in weekdays" :key="i" :value="i">{{ d }}</option>
                            </select>
                            <input type="time"
                                    class="form-control col-auto"
                                    v-model="timeOfDay">
                        </template>

                        <template v-else>
                          <label class="col-auto col-form-label pr-2">Day of the Month</label>
                          <input type="number"
                                  class="form-control col-auto mr-2 mb-3"
                                  v-model.number="monthday"
                                  min="1" max="31" style="max-width:90px">
                          <input type="time"
                                  class="form-control col-auto"
                                  v-model="timeOfDay">
                        </template>
                    </div>
                  <textarea
                    class="form-control mb-5"
                    v-model="message"
                    placeholder="Type a message..."
                    rows="8"
                  ></textarea>
                  <div class="d-flex justify-content-between">
                    <button class="btn btn-secondary" @click="$emit('close')">
                      Cancel
                    </button>
                    <button
                      class="btn btn-primary"
                      :disabled="!canAccept"
                      @click="onAccept"
                    >
                      Accept
                    </button>
                  </div>
                </div>
  
              </div>
            </div>
          </template>
        </portlet>
  
        <button class="close-btn" @click="$emit('close')">&times;</button>
      </div>
    </div>
  </template>
  
  <script>
  import Vue from 'vue';
  import store from '../../store';
  import { RIGHTS } from '../../views/roles/rights';
  
  export default {
    name: 'ReminderCreatePopup',
    data() {
        return {
            users: [],
            selectedUsers: [],
            selectAll: false,
            message: '',
            subject: '',
            recurrence: 'one-off',
            timeOfDay: '09:00',
            weekday: 1,
            monthday: 1,
            recurrenceOptions: [
              { value:'one-off', label:'One-off' },
              { value:'daily', label:'Daily' },
              { value:'weekly', label:'Weekly' },
              { value:'monthly', label:'Monthly' }
            ]
        }
    },
    computed: {
        canAccept() {
            return this.selectedUsers.length > 0 && this.recurrence && this.subject.trim() !== '' & this.message.trim() !== '';
        },
        weekdays () {
            return ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
        },
    },
    watch: {
      selectedUsers(ids) {
        this.selectAll = ids.length === this.users.length
      },
      users(newUsers) {
        this.selectAll = this.selectedUsers.length === newUsers.length
      }
    },
    async created() {
        this.rights = RIGHTS;
        await store.dispatch('users/getFlexWorkersHourApp', { 
            ApiClient: Vue.prototype.$ApiClient, 
            departments: this.$store.getters.getUserData.departments,
        }).then((res) => {
        if (res.status === 200) {
            this.users = res.data.data;
        }
        }).catch((err) => {

        });
    },
    methods: {
      toggleSelectAll() {
        if (this.selectAll) {
          this.selectedUsers = this.users.map(u => u.id)
        } else {
          this.selectedUsers = []
        }
      },
      onAccept() {
        this.$emit('confirmReminder', {
            subject : this.subject,
            message : this.message,
            userIds : this.selectedUsers,
            type : this.recurrence,
            time : this.timeOfDay,
            day  : this.recurrence==='weekly'  ? this.weekday
              : this.recurrence==='monthly' ? this.monthday
              : null
        });
        this.$emit('close')
      }
    }
  }
  </script>
  
  <style scoped>
    .overlay {
      position: fixed;
      top:0; left:0;
      width:100%; height:100%;
      background: rgba(0,0,0,0.5);
      display:flex;
      align-items:center;
      justify-content:center;
      z-index:1050;
    }
    .modal-wrapper {
      position:relative;
      width: 800px;
      max-width: 95%;
      background: #fff;
    }
    .btn {
      border-radius: 10px;
    }
    .modal-wrapper .btn-primary {
      background-color: #FF924E;
      border: none;
    }
    .modal-wrapper .btn-secondary {
      background-color: #146F70;
      border: none;
    }
    .modal-wrapper .btn-primary:hover {
      background-color: #E58346;
    }
    .modal-wrapper .btn-secondary:hover {
      background-color: #126465;
    }
    .close-btn {
      position:absolute;
      top:1.5rem; 
      right:2rem;
      background:transparent;
      border:none;
      font-size:2.5rem;
      color:#333;
      cursor:pointer;
    }
    .user-list {
      max-height: 200px;
      overflow-y: auto;
    }
    ::v-deep .m-portlet__head {
      display: none
    }
  </style>
  